/*
|---------------------------------------------------------------------
| Board Vuex Mutations
|---------------------------------------------------------------------
|
| Synchronous operations for board store
|
*/
export default {
    /* ---------------------------------- NOTAC COBRO MUTATIONS --------------------------------- */

    getItems(state) {
      return state.items
    },

}
